import { http, createWalletClient, createPublicClient, custom } from "viem";
import { localhost1337 } from "./chain";

function injected() {
  if (typeof window === "undefined") return null;
  const eth = window.ethereum;
  if (!eth) return null;
  if (Array.isArray(eth.providers))
    return eth.providers.find((p) => p?.isMetaMask) || eth.providers[0];
  return eth;
}

export const publicClient = createPublicClient({
  chain: localhost1337,
  transport: http(localhost1337.rpcUrls.default.http[0]),
});

// use MetaMask transport but force/switch chain to 1337 before any tx/read that requires chain context
export const walletClient = createWalletClient({
  chain: localhost1337,
  transport: injected()
    ? custom(injected())
    : http(localhost1337.rpcUrls.default.http[0]),
});

// call this once on app start or right before first action
export async function ensureLocal1337() {
  if (!injected()) return;
  const target = {
    chainId: "0x" + localhost1337.id.toString(16),
    chainName: "Local 1337",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: [localhost1337.rpcUrls.default.http[0]],
    blockExplorerUrls: [],
  };
  try {
    await injected().request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: target.chainId }],
    });
  } catch (e) {
    if (e?.code === 4902) {
      await injected().request({
        method: "wallet_addEthereumChain",
        params: [target],
      });
    } else {
      throw e;
    }
  }
}
